import promise from 'es6-promise';
import Locale from './locale';

import ELEMENT  from 'element-ui'

promise.polyfill();

import LinkComponents from 'src/components/index'

const Link = {
    /**
     * 安装link-ui
     * @author  韦胜健
     * @date    2019/11/7 15:03
     */
    install(Vue, option) {

        if (!option) {
            throw new Error('安装LinkUI时option必传！')
        } else {
            // console.log('LinkUI', option)
        }

        /**
         * @author  韦胜健
         * @date    2019/11/7 16:00
         * @param   option.LinkVueOption           安装LinkVue组件库所需要的参数
         * @param   option.processComponent        预处理安装的组件
         * @param   option.prefixUrl               组件请求的url前缀，旧工程一般都是 portal， 新工程一般都是
         * @param   option.publicImportUrlprefix   通用数据导入地址
         */
        const {processComponent} = option

        !!processComponent && processComponent('element-ui', ELEMENT)

        Vue.use(Locale)
		Vue.use(ELEMENT, {size: 'mini'})
        Vue.use(LinkComponents, option)
    },
}

if (typeof window !== 'undefined') {
    window.Link = Link
    window.ELEMENT = ELEMENT
    window.LinkLocale = Locale
}

export default Link
